module.exports = __webpack_public_path__ + "assets/images/rbyearend-07-desktop.jpg?v=2b86e5ad";